// Star-picker + AJAX submit for the "Write a review" page. Posts straight to
// the companion app via App Proxy — same-origin, no secrets exposed.
(function () {
  function init() {
    var form = document.querySelector("[data-marika-review-form]");
    if (!form) return;

    var urlParams = new URLSearchParams(window.location.search);
    var productHandle = form.dataset.productHandle || urlParams.get("product") || "";
    var productTitle = form.dataset.productTitle || urlParams.get("title") || "";

    var stars = Array.prototype.slice.call(form.querySelectorAll("[data-marika-star]"));
    var ratingInput = form.querySelector("[data-marika-rating-input]");
    var errorEl = form.querySelector("[data-marika-review-error]");
    var successEl = form.querySelector("[data-marika-review-success]");
    var submitButton = form.querySelector("[data-marika-review-submit]");
    var selectedRating = 0;

    function paintStars(rating) {
      stars.forEach(function (star, index) {
        star.classList.toggle("is-filled", index < rating);
        star.setAttribute("aria-pressed", index < rating ? "true" : "false");
      });
    }

    stars.forEach(function (star, index) {
      star.addEventListener("click", function () {
        selectedRating = index + 1;
        ratingInput.value = String(selectedRating);
        paintStars(selectedRating);
      });
      star.addEventListener("mouseenter", function () {
        paintStars(index + 1);
      });
    });

    form.addEventListener("mouseleave", function () {
      paintStars(selectedRating);
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      errorEl.hidden = true;
      successEl.hidden = true;

      var formData = new FormData(form);
      var customerName = String(formData.get("customerName") || "").trim();
      var comment = String(formData.get("comment") || "").trim();

      if (!customerName || !comment || selectedRating < 1) {
        errorEl.textContent = form.dataset.errorMissing || "Please add your name, a rating, and a comment.";
        errorEl.hidden = false;
        return;
      }

      submitButton.disabled = true;

      fetch(form.dataset.proxyUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          customerName: customerName,
          comment: comment,
          rating: selectedRating,
          productHandle: productHandle || undefined,
          productTitle: productTitle || undefined,
        }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("submit_failed");
          return response.json();
        })
        .then(function () {
          form.reset();
          selectedRating = 0;
          paintStars(0);
          successEl.textContent = form.dataset.successMessage || "Thank you — your review has been posted!";
          successEl.hidden = false;
        })
        .catch(function () {
          errorEl.textContent = form.dataset.errorGeneric || "Something went wrong. Please try again.";
          errorEl.hidden = false;
        })
        .finally(function () {
          submitButton.disabled = false;
        });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
